/**
 * Action types for database functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of database.
 */

// Get database constants
export const DATABASE_REQUEST_GET = 'DATABASE_REQUEST_GET';
export const DATABASE_RESPONSE_GET_SUCCESS = 'DATABASE_RESPONSE_GET_SUCCESS';
export const DATABASE_RESPONSE_GET_FAIL = 'DATABASE_RESPONSE_GET_FAIL'
